import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import { FeatureFlagProvider } from './context/FeatureFlagContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <FeatureFlagProvider>
    <App />
  </FeatureFlagProvider>
);
